function activateTab(root, tabs, activeTab, moveFocus = false) {
  const panelId = activeTab.getAttribute('aria-controls');

  for (const tab of tabs) {
    const isActive = tab === activeTab;
    tab.classList.toggle('is-active', isActive);
    tab.setAttribute('aria-selected', String(isActive));
    tab.tabIndex = isActive ? 0 : -1;
  }

  for (const panel of root.querySelectorAll('[data-top-ranking-panel]')) {
    panel.hidden = panel.id !== panelId;
  }

  if (moveFocus) activeTab.focus();
}

export default function initTopRankingTabs() {
  const root = document.querySelector('[data-top-players]');
  if (!root) return;

  const tabs = [...root.querySelectorAll('[data-top-ranking-tab]')];
  if (tabs.length === 0) return;

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activateTab(root, tabs, tab));
    tab.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

      event.preventDefault();
      let nextIndex = index;

      if (event.key === 'ArrowRight') {
        nextIndex = (index + 1) % tabs.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = (index - 1 + tabs.length) % tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = tabs.length - 1;
      }

      activateTab(root, tabs, tabs[nextIndex], true);
    });
  });
}
